import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'
import { Box, Grid, IconButton } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'

const useStyles = makeStyles((theme) => ({
  element: {
    width: '100%',
    cursor: 'pointer',
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    margin: '0px 0px 10px 0px',
    color: theme.palette.text.primary,
    '&:hover': {
      boxShadow: theme.palette.type === 'light'
        ? '1px 1px 0px #e4e4e4'
        : '1px 1px 0px #383838',
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
      '& > div > div > li > button': {
        color: theme.palette.type === 'light'
          ? theme.palette.primary.light
          : theme.palette.text.primary,
      },
    },
  },
  elementSelected: {
    width: '100%',
    cursor: 'pointer',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.primary.main,
    margin: '0px 0px 10px 0px',
    backgroundColor: theme.palette.type === 'light'
      ? 'rgba(63, 81, 181, 0.08)'
      : 'rgba(144, 202, 249, 0.12)',
    '&:hover': {
      backgroundColor: theme.palette.type === 'light'
        ? 'rgba(63, 81, 181, 0.14)'
        : 'rgba(144, 202, 249, 0.20)',
    },
  },
  emphasize: {
    borderRadius: 8,
    borderStyle: 'solid',
    borderColor: 'silver',
    borderWidth: 1,
  }
}))

interface Props {
  children?: Array<JSX.Element> | JSX.Element
  fadeOutTrigger?: boolean
  selected?: boolean
  handleClick?: () => void
  multiSelect?: boolean
  fadeTimeout?: { appear?: number; enter?: number; exit?: number }
  emphasize?: boolean
}

const ListItemBase: React.FC<Props> = (props) => {
  const {
    fadeOutTrigger,
    children,
    selected,
    handleClick,
    multiSelect = false,
    fadeTimeout = {
      enter: 100,
      exit: 500,
    },
  } = props
  const classes = useStyles()
  return (
    <Fade in={!fadeOutTrigger} timeout={fadeTimeout} unmountOnExit={true}>
      <Box boxShadow={props.emphasize ? 2 : 0} 
        className={
          clsx(
            selected ? classes.elementSelected : classes.element,
            props.emphasize && classes.emphasize) 
        }>
        <Grid container>
          {multiSelect && (
            <Grid item>
              <Grid container spacing={0} justify="center" direction="column" style={{ height: '100%' }}>
                <Grid item>
                  <IconButton
                    component="span"
                    size="small"
                    color={selected ? 'primary' : 'default'}
                    onClick={() => handleClick && handleClick()}
                    title={selected ? 'Click to deselect' : 'Click to select'}
                    style={{ margin: 4 }}
                  >
                    {selected ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs onClick={() => handleClick && handleClick()}>
            {children}
          </Grid>
        </Grid>
      </Box>
    </Fade>
  )
}

export default ListItemBase
